module.exports = __webpack_public_path__ + "img/icon-2.9d17a59e.png";